import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar, User } from "lucide-react";
import { imgSrc } from "@/lib/api";
import { formatDate } from "@/lib/format";

export const BlogCard = ({ post, compact = false }) => (
  <Link to={`/blog/${post.slug}`} className="group arch-card hover-lift block h-full overflow-hidden" data-testid={`blog-card-${post.id}`}>
    <div className={`img-zoom overflow-hidden ${compact ? "aspect-[16/10]" : "aspect-[16/9]"}`}>
      {post.coverImage ? <img src={imgSrc(post.coverImage)} alt={post.title} loading="lazy" className="h-full w-full object-cover" /> : <div className="h-full w-full bg-[var(--accent-a10)]" />}
    </div>
    <div className={compact ? "p-5" : "p-6"}>
      <div className="flex flex-wrap items-center gap-2 text-[10px] font-semibold uppercase tracking-widest text-[var(--accent-gold)]">
        <span>{post.category}</span>
      </div>
      <h3 className={`mt-2 font-serif leading-tight text-[var(--text-primary)] ${compact ? "text-xl" : "text-2xl"}`}>{post.title}</h3>
      {!compact && post.excerpt && <p className="mt-2 line-clamp-3 text-sm text-[var(--text-muted)]">{post.excerpt}</p>}
      <div className="mt-4 flex items-center justify-between border-t border-[var(--border-subtle)] pt-3 text-xs text-[var(--text-muted)]">
        <span className="flex items-center gap-3"><span className="flex items-center gap-1"><User className="h-3 w-3" />{post.author}</span><span className="flex items-center gap-1"><Calendar className="h-3 w-3" />{formatDate(post.publishedAt || post.createdAt)}</span></span>
        <ArrowUpRight className="h-4 w-4 text-[var(--accent-gold)] transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </div>
    </div>
  </Link>
);

export default BlogCard;
